export interface BPTInfo {
  expertise: { categoryId: number; level: ExpertiseLevel }[];
  motivation: { option: Motivation; openAnswer?: string }[];
  behavior: { option: Behavior; openAnswer?: string }[];
  barriers: { option: Barrier; openAnswer?: string }[];
  targets: { option: Target; openAnswer?: string };
  selfReliance: SelfReliance[];
}

export type BPTQuestionType =
  | 'interests'
  | 'expertise'
  | 'motivation'
  | 'behavior'
  | 'barrier'
  | 'target'
  | 'self-reliance'
  | 'co2-scan'
  | 'location';

export interface BPTQuestion {
  id: number;
  creationDate?: string;
  updatedDate?: string;
  text: string;
  type: '' | BPTQuestionType;
  onboarding: boolean;
  index: number;
  answers: BPTAnswer[];
}

export const textRules = [
  (value: string) => {
    if (value) return true;

    return 'Text is required.';
  },
];

export interface BPTAnswer {
  id?: number;
  creationDate?: string;
  updatedDate?: string;
  text: string;
  hint: string;
  value: string;
  index: number;
}

export const questionTypes: { title: string; value: BPTQuestionType }[] = [
  { title: 'Interests', value: 'interests' },
  { title: 'Expertise', value: 'expertise' },
  { title: 'Motivation', value: 'motivation' },
  { title: 'Behavior', value: 'behavior' },
  { title: 'Barrier', value: 'barrier' },
  { title: 'Target', value: 'target' },
  { title: 'Self Reliance', value: 'self-reliance' },
  { title: 'Co2 Scan', value: 'co2-scan' },
  { title: 'Location', value: 'location' },
];

export enum ExpertiseLevel {
  Low = 'low',
  Some = 'some',
  Expert = 'expert',
}

export enum Motivation {
  Climate = 'climate',
  Money = 'money',
  Health = 'health',
  Children = 'children',
  Conviction = 'conviction',
  Other = 'other',
  Unknown = 'unknown',
}

export enum Behavior {
  LessMeat = 'less-meat',
  PublicTransport = 'public-transport',
  Recycling = 'recycling',
  LocalProducts = 'local-products',
  Movement = 'movement',
  ElectricHybridCar = 'electric-hybrid-car',
  SustainableLiving = 'sustainable-living',
  EnergySaving = 'energy-saving',
  AlternativeTransport = 'alternative-transport',
  SustainableConsumer = 'sustainable-consumer',
  Other = 'other',
}

export enum Barrier {
  NoTime = 'no-time',
  TooExpensive = 'too-expensive',
  LackKnowledge = 'lack-knowledge',
  LackAccess = 'lack-access',
  LackSupport = 'lack-support',
  UnsureEffectiveness = 'unsure-effectiveness',
  SocialPressure = 'social-pressure',
  HabitRoutines = 'habit-routines',
  Other = 'other',
  Unknown = 'unknown',
}

export enum Target {
  ReduceEnergy = 'reduce-energy',
  SustainableTransport = 'sustainable-transport',
  SustainableFood = 'sustainable-food',
  SustainableConsumer = 'sustainable-consumer',
  Other = 'other',
  Unknown = 'unknown',
}

export enum SelfReliance {
  NoFaith = 'no-faith',
  LessFaith = 'less-faith',
  Neutral = 'neutral',
  MoreFaith = 'more-faith',
  MuchFaith = 'much-faith',
}

export enum Co2ScanInterest {
  Yes = 'yes',
  No = 'no',
  Now = 'now',
  Unknown = 'unknown',
}
